import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ProgramView from '../views/ProgramView.vue'
import ExerciseView from '../views/ExerciseView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/:programCode',
    name: 'program',
    component: ProgramView
  },
  {
    path: '/:programCode/:exerciseCode',
    name: 'exercise',
    component: ExerciseView
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '/umnaya_sportivnaya_ploshchadka/',
  routes
})

export default router
